import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";
import _defineProperty from "D:/java/\u4E00\u7F51\u901A\u529E(\u529E\u4E8B\u5927\u53852.0)/\u4E00\u7F51\u901A\u529E\u524D\u7AEFPC/pc/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from "vuex";
export default {
  name: "ToolDialog",
  components: {},
  props: ["prorData"],
  data: function data() {
    return {
      show: false,
      loading: false,
      title: "",
      thisId: "",
      // 当前数据的ID，用来判断新增、更新
      isUpData: false,
      uploadUrl: this.$http.defaults.baseURL + "/serveFile/upload",
      // 上传地址
      uploadHeader: {},
      form: {
        name: "",
        obj: [],
        linkUrl: "",
        toolUse: "0",
        imgUrl: "",
        imgId: ""
      },
      rules: {
        name: [{
          required: true,
          message: "请输入工具名称",
          trigger: "blur"
        }],
        obj: [{
          required: true,
          message: "请输选择工具对象",
          trigger: "blur"
        }],
        linkUrl: [{
          required: true,
          message: "请输入工具链接",
          trigger: "blur"
        }],
        imgUrl: [{
          required: true,
          message: "请选择工具图标",
          trigger: "blur"
        }]
      }
    };
  },
  computed: _objectSpread({}, mapGetters(["userToken"])),
  created: function created() {},
  mounted: function mounted() {},
  destroyed: function destroyed() {},
  methods: {
    // 显示弹框
    dialogShow: function dialogShow(id, name) {
      // 重置表单、显示弹框
      this.show = true;
      this.$nextTick(function () {
        this.$refs["ruleForm"].resetFields(); // 判断是编辑还是新增

        if (id) {
          this.loading = true;
          this.isUpData = true;
          this.title = name + "工具详情";
          this.getInfo(id);
        } else {
          this.isUpData = false;
          this.title = "新增工具";
        }
      });
    },
    // 确定提交
    submitForm: function submitForm(formName) {
      var _this = this;

      // 验证
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          // 如果已有上传图标，就不需要在调图标上传方法
          if (_this.form.imgId) {
            _this.submitFn(_this.form.imgId);

            return;
          } // 提交的时候上传文件


          _this.$refs.upload.submit();
        } else {
          return false;
        }
      });
    },
    //  新增 提交方法
    submitFn: function submitFn(id) {
      var _this2 = this;

      var arrObj = [];
      this.form.obj.forEach(function (e) {
        _this2.prorData.forEach(function (i) {
          if (e === i.value) {
            arrObj.push({
              id: e,
              targetName: i.label
            });
          }
        });
      });
      var data = {
        toolName: this.form.name,
        toolTarget: JSON.stringify(arrObj),
        toolUrl: this.form.linkUrl,
        toolIcon: id,
        toolUse: this.form.toolUse * 1
      }; // 如果有ID、调用更新接口

      if (this.thisId) {
        data.id = this.thisId;
        this.upDataFn(data);
        return;
      }

      this.$http.post("/tool/toolAdd", this.$qs.stringify(data)).then(function (_ref) {
        var data = _ref.data;

        if (data.resCode === 0) {
          _this2.show = false;

          _this2.$parent.initPage();

          _this2.$message.success(_this2.form.name + " 新增成功!");
        }

        _this2.loading = false;
      }).catch(function () {
        _this2.loading = false;
      });
    },
    // 更新方法
    upDataFn: function upDataFn(data) {
      var _this3 = this;

      this.$http.post("/tool/toolUpdate", this.$qs.stringify(data)).then(function (_ref2) {
        var data = _ref2.data;

        if (data.resCode === 0) {
          _this3.show = false;

          _this3.$parent.initPage();

          _this3.$message.success("工具" + _this3.form.name + " 更新成功!");
        }

        _this3.loading = false;
      }).catch(function () {
        _this3.loading = false;
      });
    },
    // 获取详情
    getInfo: function getInfo(id) {
      var _this4 = this;

      this.$http.get("/tool/toolDetail?toolId=" + id).then(function (_ref3) {
        var data = _ref3.data;

        if (data.resCode === 0) {
          var obj = [];
          eval("(" + data.resData.tool.toolTarget + ")").forEach(function (e) {
            obj.push(e.id + "");
          });
          _this4.thisId = data.resData.tool.id;
          _this4.form.name = data.resData.tool.toolName;
          _this4.form.obj = obj;
          _this4.form.linkUrl = data.resData.tool.toolUrl;
          _this4.form.imgUrl = data.resData.toolIconUrl.fileUrl;
          _this4.form.imgId = data.resData.toolIconUrl.id;
          _this4.form.toolUse = data.resData.tool.toolUse === null ? "0" : data.resData.tool.toolUse + "";
        } else {
          _this4.show = false;
        }

        _this4.loading = false;
      }).catch(function () {
        _this4.loading = false;
      });
    },
    // 设置 图片选择框中显示图标
    onChange: function onChange(file) {
      var arr = [];
      var isPNG = file.raw.type === "image/png";
      var isLt2M = file.size / 1024 < 21;

      if (!isPNG) {
        this.form.imgUrl = "";
        this.$refs.upload.clearFiles();
        this.$message.error("上传工具图标只能是 PNG 格式!");
        return;
      }

      if (!isLt2M) {
        this.form.imgUrl = "";
        this.$refs.upload.clearFiles();
        this.$message.error("上传工具图标大小不能超过 20KB!,请重新上传。");
        return;
      } // 变更图标之后重新赋值，保持只有有个图标


      arr.push(file);
      this.$refs.upload.uploadFiles = arr;
      this.form.imgId = ""; // 选择新图片，id要为空

      this.uploadHeader = {
        token: this.userToken,
        Authorization: "bearer " + this.$keycloak.token
      }; // 设置上传的 headers token

      this.form.imgUrl = URL.createObjectURL(file.raw);
    },
    // 上传成功
    // 上传成功之后、设置 已上传图标的id;
    onSuccess: function onSuccess(response) {
      var _this5 = this;

      this.$nextTick(function () {
        _this5.submitFn(response.resData[0]);
      });
    },
    // 上传错误
    onError: function onError() {
      var _this6 = this;

      this.$message.error("图标上传错误！");
      this.$nextTick(function () {
        _this6.form.imgUrl = "";
      });
    }
  },
  watch: {},
  filters: {}
};